import { fixed8DecimalPlaces, numberAdd, numberDivide, numberMutiply } from '@/libs/compute';
import { isNull, jsonParse } from '@/libs/utils';
import BigNumber from 'bignumber.js';
import { FilterPaneProps } from 'comps/FilterPane';
import { ProcureEnumDictionaryContext } from 'libs/contexts';
import { cloneDeep, isArray } from 'lodash';
import { useContext } from 'react';
import { Toast } from 'react-vant';
import {
  SettlementAuditStatusEnum,
  ThirdSettTypeEnum,
} from 'views/h5/my-center/features/settlement/constant';
import {
  AuditStatusEnum,
  FinalSettlementListEnum,
  InitiatorTypeEnum,
  InvalidAuditStatusEnum,
  OrderSettlementStatusEnum,
  PushStatusEnum,
  QuoteMode,
  SettleAuditStatusEnum,
  SettlementStatusEnum,
  SettlementSupplierStatus,
  SettmentTypeEnum,
  TenderTradeOrderTypeEnum,
  TransactionTypeEnum,
  ZyqSignStatusEnum,
} from './constant';
import type { EnumObj, OperationRecord, SettlementDocDetails, SettlementStatus } from './types';
const initiatorList = Object.values(InitiatorTypeEnum);

export const SETTLEDTOBEPAID = -1000;
const settlementOrderStatusList = Object.values(OrderSettlementStatusEnum).concat({
  value: SETTLEDTOBEPAID,
  label: '已结算-待支付',
  color: '#5476FF',
});
const approvalOrderStatusList = Object.values(SettleAuditStatusEnum);
const approvalInvalidStatusList = Object.values(InvalidAuditStatusEnum);
const settlementTypeList = Object.values(SettmentTypeEnum);
const orderTypeList = Object.values(TenderTradeOrderTypeEnum);
const transactionTypeList = Object.values(TransactionTypeEnum);
const finalSettlementList = Object.values(FinalSettlementListEnum);
const pushStatusList = Object.values(PushStatusEnum);

export const conditionList: (isPurchaser: boolean) => FilterPaneProps['conditionList'] = (
  isPurchaser,
) => {
  return [
    {
      hasMoreBtn: false,
      hotSubList: settlementTypeList.map((i) => ({ ...i, sysNo: i.value })),
      labelKey: 'label',
      prop: 'settlementTypeList',
      show: true,
      title: '结算单类型',
      totalSubList: [],
      type: 'checkbox',
    },
    {
      hasMoreBtn: false,
      hotSubList: orderTypeList.map((i) => ({ ...i, sysNo: i.value })),
      labelKey: 'label',
      prop: 'orderTypeList',
      show: true,
      title: '订单类型',
      totalSubList: [],
      type: 'checkbox',
    },
    {
      hasMoreBtn: false,
      hotSubList: transactionTypeList.map((i) => ({ ...i, sysNo: i.value })),
      labelKey: 'label',
      prop: 'transactionTypeList',
      show: true,
      title: '采购类型',
      totalSubList: [],
      type: 'checkbox',
    },
    {
      hasMoreBtn: false,
      hotSubList: settlementOrderStatusList.map((i) => ({ ...i, sysNo: i.value })),
      labelKey: 'label',
      prop: 'statusList',
      show: true,
      title: '结算单状态',
      totalSubList: [],
      type: 'checkbox',
    },
    {
      hasMoreBtn: false,
      hotSubList: approvalOrderStatusList.map((i) => ({ ...i, sysNo: i.value })),
      labelKey: 'label',
      prop: 'auditStatusList',
      show: true,
      title: '结算审批',
      totalSubList: [],
      type: 'checkbox',
    },
    {
      hasMoreBtn: false,
      hotSubList: approvalInvalidStatusList.map((i) => ({ ...i, sysNo: i.value })),
      labelKey: 'label',
      prop: 'invalidAuditStatusList',
      show: true,
      title: '作废审批',
      totalSubList: [],
      type: 'checkbox',
    },
    isPurchaser
      ? {
          hasMoreBtn: false,
          hotSubList: finalSettlementList.map((i) => ({ ...i, sysNo: i.value })),
          labelKey: 'label',
          prop: 'finalSettlementList',
          show: true,
          title: '结算阶段',
          totalSubList: [],
          type: 'checkbox',
        }
      : null,
    isPurchaser
      ? {
          hasMoreBtn: false,
          hotSubList: pushStatusList.map((i) => ({ ...i, sysNo: i.value })),
          labelKey: 'label',
          prop: 'pushBusinessStatusList',
          show: true,
          title: '推送商务状态',
          totalSubList: [],
          type: 'checkbox',
        }
      : null,
    isPurchaser
      ? {
          hasMoreBtn: false,
          hotSubList: pushStatusList.map((i) => ({ ...i, sysNo: i.value })),
          labelKey: 'label',
          prop: 'pushSelfBuildStatusList',
          show: isPurchaser,
          title: '推送自建系统状态',
          totalSubList: [],
          type: 'checkbox',
        }
      : null,
    {
      hasMoreBtn: false,
      hotSubList: initiatorList.map((i) => ({ ...i, sysNo: i.value })),
      labelKey: 'label',
      prop: 'actualInitiatorList',
      show: true,
      title: '结算发起方',
      totalSubList: [],
      type: 'checkbox',
    },
  ].filter(Boolean) as FilterPaneProps['conditionList'];
};
export const searchDates = [
  {
    title: '创建日期',
    range: ['startInDate', 'endInDate'],
  },
  {
    title: '结算日期',
    range: ['startSettlementDate', 'endSettlementDate'],
  },
  {
    title: '账单到期日',
    range: ['startBillDueDate', 'endBillDueDate'],
  },
];

export const commonActions = [
  {
    text: '结算单',
    val: 1,
    key: 'name',
    placeholder: '请输入结算单名称/结算单编号',
  },
  {
    text: '订单',
    val: 5,
    key: 'tradeName',
    placeholder: '请输入订单名称/订单编号',
  },
  {
    text: '发货单',
    val: 6,
    key: 'tradeDeliveryCode',
    placeholder: '请输入发货单编号',
  },
  {
    text: '收货单',
    val: 7,
    key: 'tradeReceivingCode',
    placeholder: '请输入收货单编号',
  },
  {
    text: '合同',
    val: 2,
    key: 'contractName',
    placeholder: '请输入合同名称/合同编号',
  },
  {
    text: '交易规则',
    val: 8,
    key: 'agreementKeyword',
    placeholder: '输入交易规则名称/编号',
  },
];

const allStatus = {
  label: '全部',
  val: 'all',
  content: 0,
};

export const tabList: Array<
  Omit<SettlementStatus, 'value'> & { content: number; val: string | number }
> = [
  allStatus,
  ...Object.values(OrderSettlementStatusEnum).map((i) => ({
    ...i,
    val: i.value,
    content: 0,
  })),
];

export const defaultQueryCriteria = {
  settlementTypeList: [], // 结算单类型
  orderTypeList: [], // 订单类型
  transactionTypeList: [], // 采购类型
  statusList: [], // 结算状态
  auditStatusList: [], //审批状态
  invalidAuditStatusList: [], //作废审批状态
  finalSettlementList: [], //结算阶段
  pushBusinessStatusList: [], //推送商务状态
  pushSelfBuildStatusList: [], //推送自建系统状态
  actualInitiatorList: [], //结算发起方
  supplierSysNo: null,
  startSettlementDate: null,
  endSettlementDate: null,
  startBillDueDate: null,
  endBillDueDate: null,
  startInDate: null,
  endInDate: null,
  projectSysNo: null,
  organizationName: null,
  organizationCode: null,
  organizationSysNo: null,
  onlyCurrentLevel: false,
  sorts: [],

  isCanPay: false, //已结算（待支付）
  waitForMe: false, // 只要看我处理的
  searchInUserName: '',
  pageSize: 10,
  pageNo: 1,
  queryTotal: true,
  keyWordType: commonActions[0].val,
};

export const findEnumItemFromvalue = <T extends { value: number }>(
  enumObj: Record<string, T>,
  value: number,
): T => {
  return Object.values(enumObj).find((emum) => emum.value === value);
};

export const SettlementAuditDes = (data: SettlementDocDetails['settlementAuditStatus']) => {
  return findEnumItemFromvalue(AuditStatusEnum, data);
};

export const TranditionSettlementAuditDes = (
  data: SettlementDocDetails['settlementAuditStatus'],
) => {
  return findEnumItemFromvalue(SettlementAuditStatusEnum, data);
};

export const SettlementStatusDes = (
  data: Pick<SettlementDocDetails, 'status' | 'thirdConfirmStatus'>,
) => {
  const enumDictionary = useContext(ProcureEnumDictionaryContext);

  const { SettlementThirdConfirmStatusEnum } = enumDictionary || {};
  const { status, thirdConfirmStatus } = data;
  if (thirdConfirmStatus === 10 || thirdConfirmStatus === 30) {
    return findEnumItemFromvalue(SettlementThirdConfirmStatusEnum as EnumObj, thirdConfirmStatus)
      ?.label;
  }
  return findEnumItemFromvalue(SettlementStatusEnum, status)?.label;
};

export const OperationContentDes = (confirmStatus: OperationRecord['confirmStatus']) => {
  return findEnumItemFromvalue(SettlementSupplierStatus, confirmStatus)?.label;
};

export const checkMaxAmount = (data: SettlementDocDetails) => {
  const maxAmount = new BigNumber(9999999999999999.9999);
  if (new BigNumber(data.amount).isGreaterThan(maxAmount)) {
    Toast.fail('结算金额过大');
    return false;
  }
  const otherMaxAmount = new BigNumber(999999999999999.99);
  if (new BigNumber(data.otherAmount).isGreaterThan(otherMaxAmount)) {
    Toast.fail('其他费用金额过大');
    return false;
  }
  if (
    data.detailList.some((item) => new BigNumber(item.settlementPrice).isGreaterThan(maxAmount))
  ) {
    Toast.fail('除税单价过大');
    return false;
  }
  return true;
};

export const comparisonOfOnlinePriceDiff = (detailList: SettlementDocDetails['detailList']) => {
  return detailList.some((item) => jsonParse(item.nowPriceContent)?.isExist);
};

export const sortBy = <T>(array: Array<T>, callback: (a: T, b: T) => boolean): Array<T> => {
  const newArray = cloneDeep(array);
  for (let i = 0; i < newArray.length; i++) {
    let count = 0;
    for (let j = i + 1; j < newArray.length; j++) {
      if (callback(newArray[i + count], newArray[j])) {
        count += 1;
        const temp = newArray[i + count];
        newArray[i + count] = newArray[j];
        newArray[j] = temp;
        j += 1;
      }
    }
    i += count;
    if (i > newArray.length) break;
  }

  return newArray;
};

export const getSpanArr = <T>(
  array: Array<T>,
  callback: (a: T, b: T) => boolean,
): Array<number> => {
  const spanArr = [];
  let pos = 0;
  for (var i = 0; i < array.length; i++) {
    if (i === 0) {
      spanArr.push(1);
    } else {
      if (callback(array[i], array[i - 1]) && array[i]) {
        spanArr[pos] += 1;
        spanArr.push(0);
      } else {
        spanArr.push(1);
        pos = i;
      }
    }
  }
  return spanArr;
};

export class PreprocessingData {
  calculateInitSettlementAmount(settlementDoc) {
    const { detailList, contractName, netPriceDateType, priceCalculationType, status, sysNo } =
      settlementDoc;

    const condtion = isNull(sysNo)
      ? netPriceDateType === 4 || contractName
      : contractName && status === SettlementStatusEnum.DRAFT.value;

    isArray(detailList) &&
      detailList.forEach((item) => {
        if (isNull(item.settlementTaxRate)) {
          item.settlementTaxRate = 0;
        }

        if (condtion) {
          if (priceCalculationType === QuoteMode.WITHOUT_TAX_TYPE.value) {
            item.settlementIncludeTaxPrice = fixed8DecimalPlaces(
              numberAdd(
                item.settlementPrice,
                numberMutiply(item.settlementPrice, item.settlementTaxRate),
              ),
            );
          } else {
            item.settlementPrice = fixed8DecimalPlaces(
              numberDivide(item.settlementIncludeTaxPrice, numberAdd(1, item.settlementTaxRate)),
            );
          }
          item.settlementAmount = fixed8DecimalPlaces(
            numberMutiply(item.settlementQuantity, item.settlementIncludeTaxPrice),
          );
        }
        item.settlementPriceTemp = item.settlementPrice;
        item.settlementIncludeTaxPriceTemp = item.settlementIncludeTaxPrice;
        item.preSettlementIncludeTaxPrice = item.settlementIncludeTaxPrice;
        item.preSettlementTaxRate = item.settlementTaxRate;
      });

    return settlementDoc;
  }

  buildReceivingList(res) {
    if (!isArray(res.detailList)) {
      res.receivingList = [];
      return;
    }
    const compareKey = res.type === 5 ? 'orderTradeSysNo' : 'orderTradeDeliveryReceivingSysNo';
    if (isArray(res.receivingList)) {
      this.buildDetailListShippingAmount(res, compareKey);
      return;
    }

    const defaultObj = {
      sysNo: null,
      orderSettlementSysNo: null,
      orderTradeDeliveryReceivingSysNo: null,
      shippingAmount: null,
      orderTradeSysNo: null,
    };

    const receivingList = [];
    res.detailList.forEach((i) => {
      !receivingList.some((j) => i[compareKey] === j[compareKey]) &&
        receivingList.push(Object.assign({}, defaultObj, { [compareKey]: i[compareKey] }));
    });
    res.receivingList = receivingList;
    this.buildDetailListShippingAmount(res, compareKey);
  }

  buildDetailListShippingAmount(res, compareKey) {
    res.receivingList.forEach((i) => {
      const item = res.detailList.find((j) => i[compareKey] === j[compareKey]);
      if (item) item.shippingAmount = i.shippingAmount;
    });
  }

  getAmount(res) {
    this.buildReceivingShippingAmount(res);
    const allSettlementAmount = res.detailList.reduce(
      (prev, cur) => numberAdd(prev, cur.settlementAmount),
      0,
    );
    const allShippingAmount = res.receivingList.reduce(
      (prev, cur) => numberAdd(prev, cur.shippingAmount),
      0,
    );
    res.otherAmount = res.otherDetailList.reduce((prev, cur) => numberAdd(prev, cur.amount), 0);

    res.amount = numberAdd(allSettlementAmount, allShippingAmount);
    res.totalAmount = numberAdd(res.amount, res.otherAmount);
  }

  buildReceivingShippingAmount(res) {
    const compareKey = 'orderTradeDeliveryReceivingSysNo';
    this.syncDetailList(res, compareKey);
    res.receivingList.forEach((i) => {
      const item = res.detailList.find((j) => i[compareKey] === j[compareKey] && j.shippingAmount);
      if (item) i.shippingAmount = item.shippingAmount;
    });
  }

  syncDetailList(res, compareKey) {
    // orderTradeDeliveryReceivingSysNo相同的，shippingAmount也应该相同
    const myMap = new Map();
    res.detailList.forEach((item) => {
      if (myMap.has(item[compareKey])) {
        myMap.get(item[compareKey]).push(item.shippingAmount);
      } else {
        myMap.set(item[compareKey], [item.shippingAmount]);
      }
    });

    myMap.forEach((value, key) => {
      let pickNo = value.filter((item) => !!item)[0] ?? 0;
      res.detailList.forEach((item) => {
        if (item[compareKey] === key) {
          item.shippingAmount = pickNo;
        }
      });
    });
  }
}

export const responseInterceptor = <T = any>(response: Promise<APIJSON<T>>) => {
  return new Promise<APIJSON<T>>(async (resolve, reject) => {
    const result = await response;
    if (result.code === 200) {
      resolve(result);
    } else {
      reject(result);
    }
  });
};

export const isNewThirdSettlementProcess = (thirdSettlementType: number) =>
  thirdSettlementType === ThirdSettTypeEnum.NEW_PROCESS;

export const SettlementSignDes = (data: SettlementDocDetails['settlementAuditStatus']) => {
  return findEnumItemFromvalue(ZyqSignStatusEnum, data);
};

export const convertToSettlementExtend = (data) => {
  return {
    supplyChainContractId: data.contractId,
    supplyChainContractCode: data.contractCode,
    supplyChainContractName: data.contractName,
    supplyChainContractAmount: data.totalAmount,
    supplyChainContractTaxRate: data.taxRateTxt,
    supplyChainContractFinancialCode: data.financialContractCode,
    supplyChainContractFinancialName: data.financialContractName,
    supplyChainContractSignDate: data.signDate,
    supplyChainContractEndDate: data.endDate,
  };
};
